import { apiClient } from './client';
import type { ClientsPageMeta } from './clients';

/**
 * Обращение в поддержку — /support (см. докблок SupportController в Laravel,
 * 1:1 старый Orchid SupportListScreen).
 */
export interface SupportTicketRow {
  id: number;
  /** Компания, к которой относится автор обращения. */
  client: string | null;
  clientId: number | null;
  authorEmail: string | null;
  title: string | null;
  /** Текстовая выжимка описания — в самом описании HTML из редактора клиента. */
  descriptionPreview: string | null;
  createdAt: string | null;
  filesCount: number;
}

export interface SupportTicketFile {
  id: number;
  name: string;
  url: string;
  size: number;
  mime: string | null;
}

export interface SupportTicketDetail {
  id: number;
  client: string | null;
  clientId: number | null;
  authorEmail: string | null;
  authorName: string | null;
  title: string | null;
  description: string | null;
  createdAt: string | null;
  files: SupportTicketFile[];
}

export interface FetchSupportParams {
  search?: string;
  sort?: string;
  page?: number;
}

export interface SupportPage {
  items: SupportTicketRow[];
  meta: ClientsPageMeta;
}

export async function fetchSupportTickets(params: FetchSupportParams = {}): Promise<SupportPage> {
  const { data } = await apiClient.get<SupportPage>('/support', { params });
  return data;
}

export async function fetchSupportTicket(id: number): Promise<SupportTicketDetail> {
  const { data } = await apiClient.get<SupportTicketDetail>(`/support/${id}`);
  return data;
}
